import React, { Component } from 'react';
import { Button, Container } from 'react-bulma-components';
import NavigationBar from '../NavigationBar/NavigationBar';
import ManagerList from './Modal/ManagerList';
import GroupList from './Modal/GroupList';
import AccountsStore from 'stores/AccountsOverview/AccountsStore';
import { toast } from 'react-toastify';


const localUserData = localStorage.getItem('userData') || '';
const userData = localUserData ? JSON.parse(localUserData) : {};
const userGroups = userData?.user?.usergroups ? userData.user.usergroups.map(x => x.group) : [];
const adminAccess = userData?.user?.isAdmin || false;
const canEdit = adminAccess ||  userGroups.includes('KeyAccountManager') ? true : false;

class Settings extends Component {
  state = {
    isManagerListOpen: false,
    isGroupListOpen: false,
  };

  openManagerList = () => {
    if(!canEdit) {
      return toast.error(`You dont have permission to edit managers`);
    }
    this.setState({ isManagerListOpen: true });
  };

  closeManagerList = () => {
    this.setState({ isManagerListOpen: false });
  };

  openGroupList = () => {
    if(!canEdit) {
      return toast.error(`You dont have permission to edit account groups`);
    }
    this.setState({ isGroupListOpen: true });
  };

  closeGroupList = () => {
    this.setState({ isGroupListOpen: false });
  };

  render() {
    const { isManagerListOpen, isGroupListOpen } = this.state;

    return (
      <>
        <NavigationBar title="Settings" />
        <Container style={{ marginTop: '20px' }}>
          <Button onClick={this.openManagerList} style={{ width: '100%' }}>Manage Key Account Managers</Button>
          <Button onClick={this.openGroupList} style={{ width: '100%', marginTop: '10px' }}>Manage Account Groups</Button>
        </Container>
        <ManagerList
          isOpen={isManagerListOpen}
          onClose={this.closeManagerList}
        />
        <GroupList
          isOpen={isGroupListOpen}
          onClose={this.closeGroupList}
        />
      </>
    );
  }
}

export default Settings;
